import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';
import { toast } from 'react-toastify';
import { t } from 'react-switch-lang';
import get from 'lodash/get';
import conversationsList from '../../../mocks/conversations';
import { requestGet, requestPost } from '../../services/real.backend';
import ConversationModel from '../../models/conversationModel';
import authStorage from '../../storages/mobx/authStorage';
import CommandsProcessor from '../../services/commandsProcessor';
import MessageModel from '../../models/MessageModel';
import backendStorage from '../../storages/external/backend';
import LinkModel from '../../models/LinkModel';
import emojisList from '../../constant/em.json';
import { API_DIALOGS_REASSIGN, API_USERS_UPDATE } from '../../services/apiPoints';
import { sendNotification } from '../../helpers/html5notificator';
import logErrorToMyService from '../../helpers/logErrorToMyService';
import UserModel from '../../models/UserModel';
import currentMessages from './storages/currentMessages';
import ContactsModel from '../../models/ContactsModel';

class ChatStorage {
  currentChatID = null;

  conversations = [];

  currentMessages = {};

  inProgress = false;

  managerLinkProgress = false;

  managerInviteLinkProgress = false;

  managerLinkDialogOpened = false;

  managerInviteLinkDialogOpened = false;

  managerLinks = [];

  showReassignDialog = false;

  searchUserString = '';

  changedFields = {};

  lastUpdated = 0;

  listLimit = 200;

  changeSearchUserString = (searchValue) => {
    this.searchUserString = searchValue;
  }

  closeCurrentDialog = () => {
    if (this.currentChat.unreaded > 0 || this.currentChat.unviewed > 0) {
      requestPost('/api/conversations/markAsReaded', {
        conversations: [this.currentChatID],
      })
        .then((response) => {
          const markedConversations = get(response, 'markedConversations');
          if (markedConversations) {
            runInAction(() => {
              Object.keys(markedConversations).map((conversationID) => {
                const index = this.conversations.findIndex((c) => c.id == conversationID);
                if (index >= 0) {
                  this.conversations[index].unreaded = 0;
                  this.conversations[index].unviewed = 0;
                }
              });
              toast.success(t('Conversation marked as readed'));
            });
          }
        });
    }
  };

  changeCurrentChatMainPhone = (field, value) => {
    if (this.conversationsList[this.currentChatID]) {
      if (!this.conversationsList[this.currentChatID].contacts) this.conversationsList[this.currentChatID].contacts = {};
      if (!this.conversationsList[this.currentChatID].contacts.value) this.conversationsList[this.currentChatID].contacts.value = '';
      this.conversationsList[this.currentChatID].contacts.value = value;
    } else {
      console.log('CURRENT CHAT NOT FOUND');
    }
  }

  get notSubscribedCount() {
    return this.conversationsList.filter((item) => item.conversationStatus == 0).length;
  }

  get currentChat() {
    const chat = this.conversations.filter((item) => item.id == this.currentChatID);
    if (chat.length > 0) {
      return chat[0];
    }
    return {
      account: {
        avatar: null,
        name: null,
        surname: null,
        id: null,
      },
      manager: {
        avatar: null,
        name: null,
        surname: null,
      },
      messages: [],
      contacts: new ContactsModel(),
    };
  }

  get changed() {
    return Object.keys(this.changedFields).filter((field) => this.changedFields[field]).length > 0;
  }

  get unreaded() {
    return this.conversationsList.reduce((prev, item) => {
      if (item.unreaded > 0) return prev + 1;
      return prev;
    }, 0);
  }

  get conversationsList() {
    return this.conversations.filter((item) => {
      const searched = this.searchUserString.toLowerCase();
      if (this.searchUserString !== '') {
        return item.account.name.toLowerCase().indexOf(searched) >= 0
        || (item.account.first_name && item.account.first_name.toLowerCase().includes(searched))
        || (item.account.last_name && item.account.last_name.toLowerCase().includes(searched))
        || (item.contacts.value && item.contacts.value.includes(searched));
      }
      return true;
    })
      .slice()
      .sort((a, b) => {
        let scoreA = 0;
        let scoreB = 0;
        if (a.unreaded > 0) scoreA += 5;
        if (b.unreaded > 0) scoreB += 5;
        if (scoreA == 0 && scoreB == 0) {
          if (a.updated_at > b.updated_at) scoreA++;
          if (a.updated_at < b.updated_at) scoreB++;
        } else {
          if (a.updated_at < b.updated_at) scoreA++;
          if (a.updated_at > b.updated_at) scoreB++;
        }
        return (scoreA > scoreB ? -1 : (scoreA < scoreB ? 1 : 0));
      })// (a.id == usersStorage.currentUser ? 1 : (a.updated_at > b.updated_at ? 1 : (a.updated_at == b.updated_at ? 0 : -1))))
    ;
  }

  constructor() {
    makeAutoObservable(this);
    // this.conversations = conversationsList;
    // this.currentChatID = conversationsList[0].id;
  }

  changeCurrentChat = (id) => {
    if (this.changed) {
      toast.error(t('You have some unsaved changes'));
      return;
    }
    this.currentChatID = id;
    if (!this.currentMessages[this.currentChatID]) this.currentMessages[this.currentChatID] = '';
  }

  loadConversations = () => {
    this.inProgress = true;
    return requestPost('/api/conversations', { from: this.lastUpdated })
      .then((resp) => {
        runInAction(() => {
          let haveNew = this.conversations.length === 0 ? -1 : 0;
          let newConv = null;
          resp.conversations.map((conv) => {
            // Проверяем есть ли в индексе такой элемент
            const convIndex = this.conversations.findIndex((c) => c.id == conv.id);
            const conversation = new ConversationModel(conv, convIndex < 0);
            if (convIndex >= 0) {
              // Элемент существует сверяемся и обновляемся при необходимости
            } else {
              // Элемента нет. Нужно создать.
            }

            if (conversation.updated_at && this.lastUpdated < conversation.updated_at.getTime()) this.lastUpdated = conversation.updated_at.getTime();
            if (convIndex >= 0) {
              // Найдено. Нужно только обновить
              if (this.conversations[convIndex].unreaded != conv.unreaded && conv.id == this.currentChatID) {
                this.loadMessagesForCurrentChat(conv.id);
              }
              if (this.conversations[convIndex].manager_id != conv.manager_id) {
                this.conversations[convIndex].manager_id = conv.manager_id;
                this.conversations[convIndex].manager = new UserModel(conv.manager);
              }
              if (this.conversations[convIndex].unreaded != conv.unreaded) this.conversations[convIndex].unreaded = conv.unreaded;
              if (this.conversations[convIndex].unviewed != conv.unviewed) this.conversations[convIndex].unviewed = conv.unviewed;
              if (this.conversations[convIndex].updated_at != conversation.updated_at) this.conversations[convIndex].updated_at = new Date(conv.updated_at);
              if (this.conversations[convIndex].conversationStatus != conv.conversationStatus) this.conversations[convIndex].conversationStatus = conv.conversationStatus;
              if (this.conversations[convIndex].contacts.id != conv.contacts.id) this.conversations[convIndex].contacts = new ContactsModel(conv.contacts);
            } else {
              this.conversations.push(conversation);
              if (haveNew === 0) haveNew = 1;
              newConv = conversation;
            }
          });
          if (haveNew > 0) {
            const interval = setInterval(() => { window.document.title = t('New conversation'); }, 500);
            try {
              const audio = new Audio('/public/income1.mp3');
              audio.play();
            } catch (e) {

            }
            sendNotification(t('New conversations'), {
              body: `${newConv.account.name}`,
              icon: newConv.account.avatar,
              image: newConv.account.avatar,
              dir: 'auto',
            });
          }
          const len = this.conversations.length;
          const removedChats = [];
          // this.conversations = this.conversations.filter((conv) => {
          //   const index = resp.conversations.findIndex((item) => conv.id == item.id);
          //   if (index >= 0) return true;
          //   removedChats.push({
          //     displayName: `${conv.account.name || ''}`.trim(),
          //   });
          //   return false;
          // });
          if (!this.currentChatID && this.conversations.length > 0) this.currentChatID = this.conversations[0].id;
          if (len != this.conversations.length) {
            this.currentChatID = null;
            toast.info(t('chat.Chats with {users} ended', { users: removedChats.map((chat) => chat.displayName).join(', ') }));
          }
          this.inProgress = false;
        });
      })
      .catch((e) => {
        this.inProgress = false;
        logErrorToMyService(e, {
          date: (new Date()).toISOString(),
          place: 'loadConversations',
        });
      });
  }

  changeCurrentMessage = (value) => {
    if (!this.currentMessages[this.currentChatID]) this.currentMessages[this.currentChatID] = '';
    this.currentMessages[this.currentChatID] = value;
  }

  sendMessage = () => {
    if (!this.currentMessages[this.currentChatID]) {
      toast.error(t('chat.Empty message'));
      return;
    }
    const message = this.currentMessages[this.currentChatID];
    const sendingMessage = {
      outMessage: {
        conversation_id: this.currentChat.id,
        account_id: this.currentChat.account.id,
        message: {
          type: 1,
          data: {
            text: message,
          },
        },
      },
    };
    requestPost('/api/conversation/viber/sendMessage', sendingMessage)
    // axios.post(`http://localhost:8080/viber/send/${channelID}/${encodeURIComponent(userID)}`, sendingMessage)
      .then((resp) => {
        runInAction(() => {
          this.currentMessages[this.currentChatID] = '';
          resp.commands.map(CommandsProcessor.process);
        });
      })
      .catch((e) => console.log(e));
  }

  sendImage = (url, type, size = 0, filename = null) => {
    // if (!this.currentMessages[this.currentChatID]) {
    //   toast.error(t('chat.Empty message'));
    //   return;
    // }
    const message = this.currentMessages[this.currentChatID];
    const messageData = {
      type,
      text: filename,
      media: url,
      url,
    };
    let messageType = 3;
    if (type == 'file') {
      messageData.sizeInBytes = size;
      messageData.filename = filename;
      messageData.url = url;
      messageType = 4;
    }

    const sendingMessage = {
      outMessage: {
        conversation_id: this.currentChat.id,
        account_id: this.currentChat.account.id,
        message: {
          type: messageType,
          data: messageData,
        },
      },
    };
    requestPost('/api/conversation/viber/sendMessage', sendingMessage)
      // axios.post(`http://localhost:8080/viber/send/${channelID}/${encodeURIComponent(userID)}`, sendingMessage)
      .then((resp) => {
        runInAction(() => {
          this.currentMessages[this.currentChatID] = '';
          resp.commands.map(CommandsProcessor.process);
        });
      })
      .catch((e) => console.log(e));
  }

  loadMessagesForCurrentChat = (id = null) => {
    currentMessages.loading = true;
    return requestGet(`/api/conversations/${id || this.currentChatID}/messages`)
      .then((resp) => {
        if (resp) {
          runInAction(() => {
            if (resp.conversationID == this.currentChatID) {
              currentMessages.messagesList = [];
              const cid = resp.conversationID;
              const conversationIndex = this.conversations.findIndex((c) => c.id == cid);
              if (conversationIndex >= 0) {
                resp.messages.reverse().map((message) => {
                  const msg = new MessageModel(message);
                  // const index = this.conversations[conversationIndex].messages.findIndex((m) => m.id == msg.id);
                  const index = currentMessages.messagesList.findIndex((m) => m.id == msg.id);
                  // if (index < 0) this.conversations[conversationIndex].messages.push(msg);
                  if (index < 0) currentMessages.messagesList.push(msg);
                });
              }
            }
            currentMessages.loading = false;
          });
        } else {
          logErrorToMyService(
            {
              message: `Get empty response from /api/conversations/${id || this.currentChatID}/messages`,
              name: 'EMPTY SERVER RESPONSE',
              stack: [],
            },
            {
              path: `/api/conversations/${id || this.currentChatID}/messages`,
              response: resp,
            },
          );
        }
      });
  }

  getManagerLink = (id) => {
    this.managerLinkProgress = true;
    this.openManagerLinkDialog();
    backendStorage
      .getManagerLinks(id)
      .then((links) => {
        this.managerLinks = [];
        links.map((link) => {
          this.managerLinks.push(new LinkModel(link));
        });
        this.managerLinkProgress = false;
      });
  }

  getManagerInviteLink = (id) => {
    this.managerInviteLinkProgress = true;
    this.openManagerInviteLinkDialog();
    backendStorage
      .getManagerLinks(id)
      .then((links) => {
        this.managerLinks = [];
        links.map((link) => {
          this.managerLinks.push(new LinkModel(link));
        });
        this.managerInviteLinkProgress = false;
      });
  }

  openManagerLinkDialog = () => { this.managerLinkDialogOpened = true; };

  openManagerInviteLinkDialog = () => { this.managerInviteLinkDialogOpened = true; };

  closeManagerLinkDialog = () => { this.managerLinkDialogOpened = false; };

  closeManagerInviteLinkDialog = () => { this.managerInviteLinkDialogOpened = false; };

  toggleManagerLinkDialog = () => { this.managerLinkDialogOpened = !this.managerLinkDialogOpened; }

  toggleManagerInviteLinkDialog = () => { this.managerInviteLinkDialogOpened = !this.managerInviteLinkDialogOpened; }

  toggleReassignDialog = () => {
    runInAction(() => {
      this.showReassignDialog = !this.showReassignDialog;
    });
  }

  reassignDialog = (id) => {
    requestPost(API_DIALOGS_REASSIGN, {
      conversationID: this.currentChat.id,
      managerID: id,
    })
      .then((r) => {
        this.showReassignDialog = false;
      });
  }

  changeStatus = (accountID, status) => {
    const conversationIndex = this.conversations.findIndex((c) => c.account.id == accountID);
    if (conversationIndex >= 0 && this.conversations[conversationIndex].id == this.currentChatID) {
    // if (conversationIndex >= 0) {
    //   this.conversations[conversationIndex].messages.map((message) => {
      currentMessages.messagesList.map((message) => {
        if (message.status < status) message.status = status;
      });
    }
  }

  addMessage = (conversationID, message) => {
    let msg = null;
    const conversationIndex = this.conversations.findIndex((c) => c.id == conversationID);
    if (conversationIndex >= 0) {
      if (conversationID == this.currentChatID) {
        // Если это сообщение для текущего чата, то сохраняем его
        // Сначала определим есть ли это сообщение уже в системе
        const index = currentMessages.messagesList.findIndex((m) => m.id == message.id);
        if (index < 0) {
          // Если сообщения еще нет, то добавим его
          runInAction(() => {
            msg = new MessageModel(message);
            currentMessages.messagesList.push(msg);
          });
        } else {
          // Здесь неплохо было бы обновить информацию о сообщении
        }
      } else {
        // Диалог не текущий, поэтому просто создадим не наблюдаемый объект сообщения
        msg = new MessageModel(message, false);
      }
      // Отправим уведомление в браузер
      sendNotification(this.conversations[conversationIndex].account.name, {
        body: msg.message,
        icon: this.conversations[conversationIndex].account.avatar,
        // image: this.conversations[conversationIndex].account.avatar,
        dir: 'auto',
      });
      // И попробуем проиграть звук
      try {
        const audio = new Audio('/public/income1.mp3');
        audio.play();
      } catch (e) {

      }
    }
  }

  changeCurrentChatAccountField = (field, value) => {
    const chatIndex = this.conversations.findIndex((item) => item.id == this.currentChatID);
    if (chatIndex < 0) {
      return false;
    }
    if (this.conversations[chatIndex].account[field] === undefined) {
      return false;
    }
    this.conversations[chatIndex].account[field] = value;
    this.changedFields[field] = true;
  }

  saveCurrentChatAccountField = (field, value) => requestPost('/api/conversation/account/saveField', {
    account_id: this.currentChat.account.id,
    field,
    value,
  })
    .then((r) => {
      const result = !!r;
      if (result) {
        this.setChangedStatusForField(field, false);
      }
      return result;
    })

  saveCurrentChatMainContact = (field, value, type) => requestPost('/api/conversation/account/saveContact', {
    conversation_id: this.currentChatID,
    contact_id: this.currentChat.contacts.id,
    contact_type: type,
    value,
  })
    .then((r) => {
      const result = !!r;
      if (result) {
        this.currentChat.contacts = new ContactsModel(r.contact);
        this.setChangedStatusForField(field, false);
      }
      return result;
    })

  setChangedStatusForField = (field, status) => {
    this.changedFields[field] = status;
  }

  loadMore = () => {
    this.listLimit += 200;
  }

  savePhone = (phone) => requestPost('/api/contacts/create', {
    phone,
  })
    .then((resp) => {
      if (resp && resp.contactID) {
        return resp;
      }
      throw new Error(`validation.${resp ? (resp.message || 'Error') : 'Error'}`);
    })

  sendInvitation = (phone, contactID, textForEsputnikViber = null) => requestPost('/api/esputnik/viber', {
    phone,
    contactID,
    managerId: authStorage.id,
    hasText: textForEsputnikViber ? true : undefined,
    customText: textForEsputnikViber || undefined,
  })
    .then((resp) => {
      if (resp?.status === 'success') {
        return resp;
      }
      throw new Error(`validation.${resp ? (resp.message || 'Error') : 'Error'}`);
    })
}

const chatStorage = new ChatStorage();

export default chatStorage;
